// extracted by mini-css-extract-plugin
module.exports = {"license":"license_license_3vfgG","title":"license_title_3muQ5","content":"license_content_3ZmKF","radio":"license_radio_2tgns"};